import type { Magics } from "alpinejs";
import { navigateWithTransition } from "../plugins/Transition";

export type SearchType = {
  [key: string | symbol]: any;

  isLoading: boolean;
  searchTerm: string;
  searchTermInput: string;
  queries: [];
  products: [];
  categories: [];
  isNoResults: boolean;

  init(): void;
  getIsSearchActive(): boolean;
  setSearchTerm(): void;
  resetSearchTerm(): void;
  search(): void;
  getSearchUrl(path: string): string;
  goToSearchPage(path: string): void;
} & Magics<{}>;

const SEARCH_OPTIONS = {
  "resources[type]": "product,collection,query",
  "resources[limit]": "4",
  "resources[limit_scope]": "each",
};

const initialSearch = new URLSearchParams(window.location.search).get("q");

export const Search = () =>
  <SearchType>{
    isLoading: false,
    searchTerm: initialSearch || "",
    searchTermInput: initialSearch || "",
    queries: [],
    products: [],
    categories: [],
    isNoResults: false,

    getIsSearchActive() {
      return !!this.searchTerm && (this.products.length || this.isNoResults);
    },

    init() {
      if (this.searchTerm) {
        this.search();
      }

      this.$watch("searchTerm", (value) => {
        if (value) {
          this.search();
        }
      });
    },

    setSearchTerm() {
      if (this.searchTerm.trim() !== this.searchTermInput.trim()) {
        this.isLoading = true;
      }

      this.searchTerm = this.searchTermInput.trim();
    },

    resetSearchTerm() {
      this.searchTermInput = "";
      this.setSearchTerm();
      this.isLoading = false;
    },

    search() {
      this.isLoading = true;

      const urlParams = new URLSearchParams(SEARCH_OPTIONS);
      urlParams.set("q", this.searchTerm);
      const searchQuery = urlParams.toString();

      fetch(`${window.Shopify.routes.root}search/suggest.json?${searchQuery}`)
        .then((response) => response.json())
        .then((suggestions) => {
          this.queries = suggestions.resources.results.queries;
          this.products = suggestions.resources.results.products;
          this.categories = suggestions.resources.results.collections;
          this.isNoResults =
            !this.queries.length &&
            !this.products.length &&
            !this.categories.length;
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => (this.isLoading = false));
    },

    goToSearchPage(path) {
      // TODO: implement fallback
      navigateWithTransition(this.getSearchUrl(path), {
        type: "search",
        animate: true,
        data: {
          search: this.searchTermInput,
        },
      });
    },

    getSearchUrl(path) {
      return this.searchTermInput
        ? `${path}?q=${encodeURIComponent(this.searchTermInput.trim())}`
        : path;
    },
  };
